import { render } from "./AdminExport.vue?vue&type=template&id=351aec00"
import script from "./AdminExport.vue?vue&type=script&lang=js"
export * from "./AdminExport.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zellwegv/repos-work/fw-312-bird-identification-game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__